<template>
  <div class="day-stock-list print-font" v-loading="showData">
    <div class="day-main-body print-font" ref="day-main-body">
      <div ref="sortby-goods" class="sortby-goods printpage print-font">
        <div class="title text-center">每日备货清单-按商品汇总</div>
        <el-table :data="goodsTableData" style="width: 100%">
          <el-table-column type="index" label="序号" width="45">
          </el-table-column>
          <el-table-column prop="name" label="商品名称"> </el-table-column>
          <el-table-column prop="self_code" label="商品编号" width="95">
          </el-table-column>

          <el-table-column prop="ruigu_code" label="锐锢编码" width="75">
          </el-table-column>
          <el-table-column prop="total_amount" label="数量" width="45">
          </el-table-column>
          <el-table-column prop="storage_pos" label="库位" width="90">
          </el-table-column>
          <el-table-column prop="out_ware_day" label="要求发货日" width="100">
          </el-table-column>
        </el-table>
        <div class="total text-center">
          合计
          <span class="totalnum">{{ goodsTotalNum }}</span>
        </div>
        <div style="margin-bottom:15px;"></div>

        <div v-if="showPagePrint" style="page-break-after: always;"></div>
      </div>

      <div v-if="showPagePrint" style="page-break-after: always;"></div>

      <div ref="sortby-order" class="sortby-order print-font">
        <div class="title text-center" v-if="!showPagePrint">
          按订单分拣汇总
        </div>
        <div
          class="order-content printpage"
          v-for="item in mainTableData"
          :key="item.order_number"
        >
          <div v-if="showPagePrint" class="title text-center">
            按订单分拣汇总
          </div>
          <div class="order-title bottom-gap">
            <span class="order-title-item right-gap">
              <span class="order-title-label">主订单号</span>
              <span class="num">{{ item.main_number }}</span>
            </span>
            <span class="order-title-item right-gap">
              <span class="order-title-label">客户</span>
              <span class="phone" v-if="isFactory">{{ item.mobile }}</span>
              <span class="phone" v-else>{{
                item.mobile | before3after4
              }}</span>
            </span>
            <span class="order-title-item">
              <span class="order-title-label">编号</span>
              <span class="code">
                <span class="code" v-if="item.serial_number">{{
                  item.serial_number
                    .split("-")
                    .slice(3)
                    .join("-")
                }}</span>
                <span class="code" v-if="isZhifaOrFactory && item.express"
                  >({{ item.express }})</span
                >
              </span>
            </span>
          </div>
          <el-table :data="item.orderTableData" style="width: 100%">
            <el-table-column type="index" label="序号" width="45">
            </el-table-column>
            <!--<el-table-column
              prop="main_number"
              label="主订单号"
              width="120"
            >
            </el-table-column>-->
            <el-table-column prop="name" label="商品名称"> </el-table-column>
            <el-table-column prop="self_code" label="商品编号" width="95">
            </el-table-column>
            <el-table-column prop="ruigu_code" label="锐锢编码" width="75">
            </el-table-column>
            <el-table-column prop="amount" label="数量" width="45">
            </el-table-column>
            <el-table-column prop="storage_pos" label="库位" width="90">
            </el-table-column>
            <el-table-column prop="order_number" label="子订单号" width="120">
            </el-table-column>
          </el-table>
          <div class="total text-center total">
            合计
            <span class="totalnum">{{ item.orderTotalNum }}</span>
          </div>
          <div style="margin-bottom:15px;"></div>
          <div v-if="showPagePrint" style="page-break-after: always;"></div>
        </div>

        <div v-if="!showPagePrint" class="orderTotal text-center total">
          订单总合计:{{ orderAllNum }}
        </div>
      </div>
    </div>
    <div class="day-btns">
      <el-button type="primary" size="small" @click="myPrint">打印</el-button>
      <el-button type="primary" size="small" @click="pagePrint"
        >分页打印</el-button
      >
      <!--<el-button type="primary" size="small" @click="exportExcel">导出</el-button>-->
    </div>
    <div class="date">
      <span>要求发货日</span>
      <el-date-picker
        v-model="outWareDate"
        @change="changeDate"
        align="right"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
import { currentTime } from "@/utils/utils";
import { before3after4Num } from "@/utils/filter";
import print from "@/utils/mixins/print";
import {
  getBigorderStockListing,
  getOrderDetail,
  // printPage,
  getOutStockDetail
} from "@/models/orderModel";
export default {
  mixins: [print],
  data() {
    return {
      isZhifaOrFactory: true,
      isFactory: true,
      showData: true,
      goodsTableData: [], // 按商品汇总数据
      mainTableData: [], // 按分拣汇总数据
      orderTableData: [],
      goodsTotalNum: 0,
      outWareDate: "",
      orderAllNum: 0,
      showPagePrint: false // 是否是分页打印
    };
  },
  filters: {
    before3after4(val) {
      if (val) {
        return before3after4Num(val);
      } else {
        return "";
      }
    }
  },
  mounted() {
    // if (localStorage.getItem('shop_type') === '2') {
    //   this.isFactory = true
    // }
    // let currentDate = new Date()
    // let year = currentDate.getFullYear()
    // let month = currentDate.getMonth() + 1
    // let day = currentDate.getDate()
    // this.outWareDate = year + '-' + month + '-' + day
    this.getStockListing();
  },
  methods: {
    changeDate(val) {
      this.getStockListing();
    },
    myPrint() {
      this.showPagePrint = false;
      setTimeout(() => {
        this.browser_print("day-main-body");
      }, 1000);
    },
    // 分页打印导出PDF
    async pagePrint() {
      this.showPagePrint = true;
      setTimeout(() => {
        this.browser_print("day-main-body");
      }, 1000);
      setTimeout(() => {
        this.showPagePrint = false;
      }, 1500);
    },
    // 导出
    exportExcel() {
      let wb = XLSX.utils.table_to_book(
        document.querySelector(".day-main-body")
      );
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        let fileName = currentTime() + ".xlsx";
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream"
          }),
          fileName
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    async getOrderTableData(orderData) {
      let params = {
        id: orderData.id
      };
      let data = (await getOrderDetail(params)) || [];
      let filterData = data.filter(item => {
        if (item.hasOwnProperty("status")) {
          return item.status > 0;
        }
      });

      let num = 0;
      for (let i of filterData) {
        num = num + parseInt(i.amount);
        i.self_code = i.self_code || "";
        i.storage_pos = i.storage_pos || "";
      }
      this.$set(orderData, "orderTableData", filterData);
      this.$set(orderData, "orderTotalNum", num);
      this.orderAllNum = this.orderAllNum + num;
    },
    async getStockListing() {
      this.showData = true;
      this.orderAllNum = 0;
      this.goodsTotalNum = 0;
      let params = { order_type: 1 };
      if (this.outWareDate) {
        params.start_created_at = this.outWareDate;
      }
      let data = await getBigorderStockListing(params);

      let mainTableData = data.order;
      console.log(mainTableData, "this.mainTableData");
      this.goodsTableData = data.goods;

      for (let i of this.goodsTableData) {
        // i.mo_statusName = getOdStatusList().mo_statusList.filter(item => item.value === i.mo_status)[0].label
        this.goodsTotalNum =
          parseInt(this.goodsTotalNum) + parseInt(i.total_amount);
        i.self_code = i.self_code || "";
        i.storage_pos = i.storage_pos || "";
      }
      if (mainTableData.length > 0) {
        let ids = [];
        mainTableData.forEach(item => {
          ids.push(item.id);
        });
        let idsData = await getOutStockDetail({ ids: JSON.stringify(ids) });
        mainTableData.forEach(item => {
          if (idsData.data.hasOwnProperty(item.id)) {
            let data = idsData.data[item.id];
            let filterData = data.filter(item => {
              if (item.hasOwnProperty("status")) {
                return item.status > 0;
              }
            });
            let num = 0;
            for (let i of filterData) {
              num = num + parseInt(i.amount);
              i.self_code = i.self_code || "";
              i.storage_pos = i.storage_pos || "";
            }
            item.orderTableData = filterData;
            item.orderTotalNum = num;
            this.orderAllNum = this.orderAllNum + num;
          }
        });
      }
      // for (let i of this.mainTableData) {
      //   this.getOrderTableData(i)
      // }

      // this.getOrderTableData(this.mainTableData[0])
      this.mainTableData = mainTableData;
      this.showData = false;
    }
  }
};
</script>
<style type="text/css" media="print">
table {
  width: 100%;
  font-size: 12px;
}
td {
  text-align: center;
}
th {
  text-align: center;
}
.text-center {
  text-align: center;
}
.order-width {
  width: 120px;
}
.right-gap {
  padding-right: 7px;
  display: inline-block;
}
.bottom-gap {
  margin-bottom: 7px;
}
.total {
  font-weight: 500;
}
</style>

<style lang="scss">
.day-main-body {
  width: 700px;
}
.day-stock-list {
  // font-family: "SimHei","Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
  padding: 10px;
  width: 100%;
  .sortby-goods {
    width: 100%;
    height: 100%;
    padding-bottom: 5px;
    border-bottom: 1px solid #000;
  }
  .title {
    text-align: center;
    font-size: 16px;
    padding: 10px 0;
    font-weight: 700;
  }
  .total {
    text-align: center;
    padding: 10px 0;
    font-weight: 700;
    .totalnum {
      display: inline-block;
      padding-left: 15px;
      font-size: 16px;
    }
  }
  .sortby-order {
    width: 100%;
    .order-title {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      font-weight: bold;
      .order-title-item {
        margin: 10px 10px;
      }
      .order-title-label {
        padding-right: 5px;
      }
      .code {
        font-size: 20px;
        display: inline-block;
        min-width: 60px;
      }
      // padding-bottom: 10px;
      // .main {
      //   font-weight: bold;
      // }
      // .num {
      //   font-size: 12px;
      //   color: #409eff;
      //   text-decoration: underline;
      //   margin-right: 80px;
      // }
    }
  }
  .printpage {
    // width: 700px;
  }
  .orderTotal {
    text-align: center;
    font-weight: bold;
  }
  .day-btns {
    text-align: center;
  }
  .date {
    position: absolute;
    top: 10px;
    right: 60px;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/day-stock-list.vue